import { millsToTimeString } from 'src/helpers/date-helpers';
import Style from '../panelStyles.module.scss';
import { isFieldWithOptions } from 'src/components/formEditor/uiEditor/uiEditor-helper';
import {
  FormFieldProps,
  GlobalProps,
  isDateRangeField,
  isTagInputField,
  isTimeField,
} from '../../../types/BaseControlTypes';
import { Chip } from '../uiKit/chip/chip';

export type FieldsTypes = 'withOptions' | 'dateRange' | 'tagInput' | 'time' | 'default';

export const getFieldType = (nodeName: string, props?: GlobalProps): FieldsTypes => {
  if (isFieldWithOptions(props)) return 'withOptions';
  if (isDateRangeField(nodeName)) return 'dateRange';
  if (isTagInputField(nodeName)) return 'tagInput';
  if (isTimeField(nodeName)) return 'time';

  return 'default';
};

export const defaultValueRenderers: Record<FieldsTypes, (props: GlobalProps) => React.ReactNode> = {
  withOptions: (props) => {
    return props.options
      ?.filter((o) => props.defaultValue?.includes(o.key))
      .map((o) => <div key={o.key}>{o.value}</div>);
  },

  dateRange: (props) => {
    const [from, to] = props.defaultValue ?? [];
    return `${from} — ${to}`;
  },

  tagInput: (props) => {
    return (
      <div className={Style.tagsDefaultValue}>
        {props.defaultValue?.map((tag: string) => (
          <Chip key={tag} text={tag} />
        ))}
      </div>
    );
  },

  time: (props) => {
    return millsToTimeString(props.defaultValue ?? 0);
  },

  default: (props) => {
    return (props as FormFieldProps).defaultValue;
  },
};
